<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane :label="$t('CargoMsg.Cargo_NoSubmit_SR')" name="unSubmitted">
          <tab-un-submitted source="unSubmitted" config-model="190806" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_AwaitApproval_SR')" name="approving" :lazy="true">
          <tab-approving source="approving" config-model="190807" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_Approved_SR')" name="approved" :lazy="true">
          <tab-approved source="approved" config-model="190808" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabUnSubmitted from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/tabBillPayment'
import tabApproving from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/tabBillPayment'
import tabApproved from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/tabBillPayment'

export default {
  name: 'BillPaymentOfSiRui',
  components: {
    tabUnSubmitted, // 付款申请-思锐版本-未提交页签
    tabApproving, // 付款申请-思锐版本-审批中页签
    tabApproved // 付款申请-思锐版本-审批完成页签
  },
  data() {
    return {
      activeTabName: 'unSubmitted'
    }
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
